export default __webpack_public_path__ + "405c2007d5841a73d4c2b47bef4ed16c.jpg";